import { Box, Typography } from '@mui/material'

import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import Social from '~/layouts/app/footer/termsAndSocial/social'

function TermsAndSocial() {
  const { partner } = usePartnerCentralized()

  return (
    <Box sx={{ mt: '2rem' }}>
      <Typography>
        &copy; 2025 {partner.domain}. All rights reserved.
      </Typography>
      <Social />
    </Box>
  )
}

export default TermsAndSocial
